import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "cards-container mb-5 mt-3 mb-xl-10 row gy-5 g-xl-8" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "single-card col-sm-12 col-md-6 h-100" }
const _hoisted_4 = { class: "card mb-xl-8 mx-auto d-flex text-center justify-content-start p-10 position-relative h-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/valored/dashboard_1.png",
  alt: "",
  class: "survey-iii-back1_img position-absolute"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/valored/dashboard_2.png",
  alt: "",
  class: "survey-iii-back2_img position-absolute"
}, null, -1)
const _hoisted_7 = { class: "z-index-1 text-start" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/valored/survey-iii-1.png",
  alt: "",
  class: "card-content-image"
}, null, -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "text-start fs-3 fw-bold text-green mb-12 h-50px mt-20" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "fs-1 fw-bold" }
const _hoisted_13 = {
  key: 0,
  class: "row container-buttons-card"
}
const _hoisted_14 = { class: "col-md-6 d-grid pe-3 btn-result-dashboard" }
const _hoisted_15 = { class: "d-md-inline" }
const _hoisted_16 = { class: "col-md-6 d-grid ps-3" }
const _hoisted_17 = { class: "d-md-inline" }
const _hoisted_18 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_19 = { class: "col-md-6 d-grid" }
const _hoisted_20 = {
  key: 0,
  class: "d-md-inline"
}
const _hoisted_21 = {
  key: 1,
  class: "d-md-inline"
}
const _hoisted_22 = { class: "single-card col-sm-12 col-md-6 h-100" }
const _hoisted_23 = { class: "card p-10 mb-xl-8 w-80 mx-auto justify-content-start d-flex text-center h-100" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/valored/dashboard_3.png",
  alt: "",
  class: "survey-iii-back3_img position-absolute"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/valored/dashboard_4.png",
  alt: "",
  class: "survey-iii-back4_img position-absolute"
}, null, -1)
const _hoisted_26 = { class: "z-index-1 text-start" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/valored/survey-plus-1.png",
  alt: "",
  class: "card-content-image"
}, null, -1)
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "text-start fs-3 fw-bold text-custom-cyan mb-12 h-50px mt-20" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "fs-1 fw-bold" }
const _hoisted_33 = {
  key: 0,
  class: "row container-buttons-card"
}
const _hoisted_34 = { class: "col-md-6 d-grid pe-3 btn-result-dashboard" }
const _hoisted_35 = { class: "d-md-inline" }
const _hoisted_36 = { class: "col-md-6 d-grid ps-3" }
const _hoisted_37 = { class: "d-md-inline" }
const _hoisted_38 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_39 = { class: "col-md-6 d-grid" }
const _hoisted_40 = {
  key: 0,
  class: "d-md-inline"
}
const _hoisted_41 = {
  key: 1,
  class: "d-md-inline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_add_company_setting_modal = _resolveComponent("add-company-setting-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", {
                  class: "card-content-text text-start fw-bold text-dark-blue mb-12 mt-10 h-50px",
                  innerHTML: _ctx.translate('DASHBOARD_III_DESCRIPTION')
                }, null, 8, _hoisted_9),
                _createElementVNode("div", _hoisted_10, [
                  (
                  _ctx.iii &&
                  _ctx.optionYearlyPeriod.company_year_iii_is_completed[
                    _ctx.current_yearly_period
                  ]
                )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                        _createTextVNode(_toDisplayString(_ctx.translate("TITLE_CURRENT_RESULT")) + ": ", 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.iii.iii) + " / 100", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (
                _ctx.optionYearlyPeriod.company_year_iii_is_completed[
                  _ctx.current_yearly_period
                ]
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_router_link, {
                          "active-class": "active",
                          to: _ctx.reportUrl,
                          class: "btn btn-dark-blue"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_15, [
                              _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_RESULT")) + " ", 1),
                              _createVNode(_component_inline_svg, {
                                src: "/media/vectorial/arrow-right.svg",
                                class: "ms-5"
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          "active-class": "active",
                          to: _ctx.surveyUrl,
                          class: "btn btn-light text-dark-blue button-modify-dashboard"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_17, [
                              _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_MODIFICATION")) + " ", 1),
                              _createVNode(_component_inline_svg, {
                                src: "/media/vectorial/pen.svg",
                                class: "ms-5"
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          "active-class": "active",
                          to: _ctx.surveyUrl,
                          class: "btn btn-dark-blue"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.isIIIPending.includes(parseInt(_ctx.current_yearly_period)))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                  _createTextVNode(_toDisplayString(_ctx.translate("DASHBOARD_BUTTON_CONTINUE_THE_SURVEY")) + " ", 1),
                                  _createVNode(_component_inline_svg, {
                                    src: "/media/vectorial/arrow-right.svg",
                                    class: "ms-5",
                                    "aria-hidden": "true"
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                  _createTextVNode(_toDisplayString(_ctx.translate("DASHBOARD_BUTTON_START_THE_SURVEY")) + " ", 1),
                                  _createVNode(_component_inline_svg, {
                                    src: "/media/vectorial/arrow-right.svg",
                                    class: "ms-5",
                                    "aria-hidden": "true"
                                  })
                                ]))
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", {
                  class: "card-content-text text-start fw-bold text-dark-blue mb-12 mt-10 h-50px",
                  innerHTML: _ctx.translate('DASHBOARD_PLUS_DESCRIPTION')
                }, null, 8, _hoisted_28),
                (_ctx.current_yearly_period > 2020)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        (_ctx.rank.label !== undefined)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                              _createTextVNode(_toDisplayString(_ctx.translate("TITLE_CURRENT_RESULT")) + ": ", 1),
                              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.rank[_ctx.translateKey("label")]), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.rank.label)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_router_link, {
                                "active-class": "active",
                                to: _ctx.surveyPlusReportUrl,
                                class: "btn btn-dark-blue"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_35, [
                                    _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_RESULT")) + " ", 1),
                                    _createVNode(_component_inline_svg, {
                                      src: "/media/vectorial/arrow-right.svg",
                                      class: "ms-5"
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_router_link, {
                                "active-class": "active",
                                to: _ctx.surveyPlusUrl,
                                class: "btn btn-light text-dark-blue button-modify-dashboard"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_37, [
                                    _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_MODIFICATION")) + " ", 1),
                                    _createVNode(_component_inline_svg, {
                                      src: "/media/vectorial/pen.svg",
                                      class: "ms-5"
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_router_link, {
                                "active-class": "active",
                                to: _ctx.surveyPlusUrl,
                                class: "btn btn-dark-blue"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.isSurveyPlusPending.includes(parseInt(_ctx.current_yearly_period)))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                        _createTextVNode(_toDisplayString(_ctx.translate("DASHBOARD_BUTTON_CONTINUE_THE_SURVEY")) + " ", 1),
                                        _createVNode(_component_inline_svg, {
                                          src: "/media/vectorial/arrow-right.svg",
                                          class: "ms-5",
                                          "aria-hidden": "true"
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                        _createTextVNode(_toDisplayString(_ctx.translate("DASHBOARD_BUTTON_START_THE_SURVEY")) + " ", 1),
                                        _createVNode(_component_inline_svg, {
                                          src: "/media/vectorial/arrow-right.svg",
                                          class: "ms-5",
                                          "aria-hidden": "true"
                                        })
                                      ]))
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode(_component_add_company_setting_modal, {
            ref: "addCompanySettingModalRef",
            isCompanyCreate: _ctx.isCompanyCreate
          }, null, 8, ["isCompanyCreate"])
        ]))
      : _createCommentVNode("", true)
  ]))
}